export default "__VITE_ASSET__BkmyHgjs__"